import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24627f2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "games-headline" }
const _hoisted_2 = {
  class: "games-overview",
  purple: ""
}
const _hoisted_3 = {
  class: "games-layout",
  "data-qe-id": "games-overview"
}
const _hoisted_4 = { class: "game-slot-content" }
const _hoisted_5 = { class: "game-number" }
const _hoisted_6 = {
  key: 0,
  class: "game-finished"
}
const _hoisted_7 = { "data-qe-id": "score" }
const _hoisted_8 = {
  key: 1,
  class: "game-pending"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icf-info" }, null, -1))
const _hoisted_10 = {
  key: 2,
  class: "game-open"
}

import { computed } from 'vue'
import { GameUi } from '@/model/Tournament'
import GameState from '@/model/GameState'

export default /*#__PURE__*/_defineComponent({
  __name: 'CGamesOverview',
  props: {
    isHistoryMode: { type: Boolean, default: false },
    games: {}
  },
  emits: ['onGame'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const firstSlotOpen = computed(() => {
  const first = props.games.filter((game) => game.state === GameState.OPEN)[0]
  return first && first.idx
})

function onGame(game: GameUi) {
  if (game.state === GameState.FINISHED) {
    emit('onGame', game)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_c_horizontal_progress = _resolveComponent("c-horizontal-progress")!
  const _component_t_card = _resolveComponent("t-card")!
  const _component_t_tooltip = _resolveComponent("t-tooltip")!
  const _component_t_container = _resolveComponent("t-container")!

  return (_openBlock(), _createBlock(_component_t_container, { class: "t-text" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('tViews.joined.title_gamesSection')), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game, idx) => {
            return (_openBlock(), _createBlock(_component_t_tooltip, {
              key: idx,
              class: "games-slot-wrap tooltip-offset",
              disabled: game.state !== 'pending',
              text: _ctx.$t('gamesOverview.gameStates.pending_title')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_t_card, {
                  onClick: ($event: any) => (onGame(game)),
                  class: _normalizeClass(["games-slot", !_ctx.isHistoryMode && idx === firstSlotOpen.value ? 'empty-open' : game.state]),
                  "data-qe-id": `game-slot-${game.state}`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, [
                        _createElementVNode("span", null, _toDisplayString(idx + 1), 1)
                      ]),
                      (game.state === 'finished')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(game.score), 1)
                          ]))
                        : (game.state === 'pending')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _hoisted_9,
                              _createVNode(_component_c_horizontal_progress, { color: "midGreen" })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_10))
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick", "class", "data-qe-id"])
              ]),
              _: 2
            }, 1032, ["disabled", "text"]))
          }), 128))
        ])
      ])
    ]),
    _: 3
  }))
}
}

})